import script from "./AddCertificateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddCertificateModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddCertificateModal.vue?vue&type=style&index=0&id=fdbc2100&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdbc2100"]])

export default __exports__